module.exports = __webpack_public_path__ + "img/tokuten_ico5.d242aa4e.png";